module.exports = __webpack_public_path__ + "static/media/Water.bb35d695.svg";